import { ValidationRuleset } from 'vuelidate';
import { User } from '@/store/models';
import { email, minLength, required } from 'vuelidate/lib/validators';

export type TUser = { params: User; validationGroup: string[] };

const existsEmail = () => {
  return true;
};

export const userValidator: ValidationRuleset<TUser> = {
  params: {
    initialPassword: {
      // required,
      // minLength: minLength(6)
    },
    coach: {
      email: {
        required,
        email,
        existsEmail
      },
      firstName: {
        required
      },
      lastName: {
        required
      },
      companyName: {
        required
      },
      department: {
        required
      },
      jobTitle: {
        required
      }
    },
    country: {
      required
    },
  }
};
